import {
  GET_USER, GET_USERS_ERROR, GET_REFEST, GET_REFXID, GET_REFPLAN, GET_FACTCAR, GET_DISPOSITIVO,
  GET_TIPOBOLSA, GET_PERMISOSALL, GET_UBICACION, GET_LUGAR, GET_CLIENTE, GET_USUARIO, GET_AREA,
  GET_CARGO, GET_ROL, GET_MATERIAL, GET_NORMA, GET_REPORTES, GET_CERTIFICADO, GET_PERMISO_ID, GET_USUARIOMUETRE, GET_ALLREGREF, GET_REFPLANALL
} from "./actions";

const initialState = {
  usuario: [],
  usuarioError: null, // Guardar el mensaje de error
  estadoref: [],
  refid: [],
  refplan: [],
  facarga: [],
  dispositivo: [],
  tipobolsa: [],
  permisos: [],
  ubicaciones: [],
  lugar: [],
  clientes: [],
  usuarios: [],
  area: [],
  cargo: [],
  rol: [],
  material: [],
  norma: [],
  reporte: [],
  certificado: [],
  permisouser: [],
  usuariomuetre: [],
  allregref: [],
  refplanall: []
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER:
      return { ...state, usuario: action.payload, usuarioError: null };
    case GET_USERS_ERROR:
      return { ...state, usuarioError: action.payload };
    case GET_REFEST:
      return { ...state, estadoref: action.payload };
    case GET_REFXID:
      return { ...state, refid: action.payload };
    case GET_REFPLAN:
      return { ...state, refplan: action.payload };
    case GET_FACTCAR:
      return { ...state, facarga: action.payload };
    case GET_DISPOSITIVO:
      return { ...state, dispositivo: action.payload };
    case GET_TIPOBOLSA:
      return { ...state, tipobolsa: action.payload };
    case GET_PERMISOSALL:
      return { ...state, permisos: action.payload };
    case GET_UBICACION:
      return { ...state, ubicaciones: action.payload };
    case GET_LUGAR:
      return { ...state, lugar: action.payload };
    case GET_CLIENTE:
      return { ...state, clientes: action.payload };
    case GET_USUARIO:
      return { ...state, usuarios: action.payload };
    case GET_AREA:
      return { ...state, area: action.payload };
    case GET_CARGO:
      return { ...state, cargo: action.payload };
    case GET_ROL:
      return { ...state, rol: action.payload };
    case GET_MATERIAL:
      return { ...state, material: action.payload };
    case GET_NORMA:
      return { ...state, norma: action.payload };
    case GET_REPORTES:
      return { ...state, reporte: action.payload };
    case GET_CERTIFICADO:
      return { ...state, certificado: action.payload };
    case GET_PERMISO_ID:
      return { ...state, permisouser: action.payload };
    case GET_USUARIOMUETRE:
      return { ...state, usuariomuetre: action.payload };
    case GET_ALLREGREF:
      return { ...state, allregref: action.payload };
    case GET_REFPLANALL:
      return { ...state, refplanall: action.payload };
    default:
      return state;
  }
};

export default rootReducer;
